import React, { useEffect, useRef } from "react";
import styles from "./Carousel.module.scss";

const Carousel = () => {
  const carouselRef = useRef(null);

  const bannerItems = [
    { text: "Simplify Collections" },
    { text: "Automate Payments" },
    { text: "Boost Efficiency" },
  ];

  useEffect(() => {
    const carousel = carouselRef.current;
    let scrollAmount = 0;

    const scrollCarousel = () => {
      scrollAmount += 1;
      if (scrollAmount >= carousel.scrollWidth / 2) {
        scrollAmount = 0;
      }
      carousel.scrollTo({ left: scrollAmount, behavior: "smooth" });
    };

    const interval = setInterval(scrollCarousel, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.carouselWrapper}>
      <div className={styles.carousel} ref={carouselRef}>
        {bannerItems.map((item, index) => (
          <span key={index} className={styles.carouselItem}>
            {item.text}
            <span className={styles.icon}>*</span>
          </span>
        ))}
        {/* Duplicate items for seamless infinite effect */}
        {bannerItems.map((item, index) => (
          <span key={`duplicate-${index}`} className={styles.carouselItem}>
            {item.text}
            <span className={styles.icon}>*</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
